import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { PBDCBeneficioPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-beneficio-pdf';
import { PBDCFundoPrevidencialPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-fundo-previdencial-pdf';
import { PBDCReservaPoupancaPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-reserva-poupanca-pdf copy';
import { PBDCSuperavitPdf } from '../../shared/services/documentos-pdf-imprimir/Plano/pbdc/pbdc-superavit-pdf';
import { PbdcBeneficioTemporarioComponent } from './pbdc-beneficio-temporario/pbdc-beneficio-temporario.component';
import { PbdcFundoPrevidencialComponent } from './pbdc-fundo-previdencial/pbdc-fundo-previdencial.component';
import { PbdcReservaPoupancaComponent } from './pbdc-reserva-poupanca/pbdc-reserva-poupanca.component';
import { PbdcSuperavitComponent } from './pbdc-superavit/pbdc-superavit.component';
import { PbdcRoutingModule } from './router/pbdc.router';
import { PbdcService } from './service/pbdc.service';
import { PbdcDashboardComponent } from './pbdc-dashboard/pbdc-dashboard.component';


@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        PbdcRoutingModule
    ],
    declarations: [
        PbdcFundoPrevidencialComponent,
        PbdcReservaPoupancaComponent,
        PbdcSuperavitComponent,
        PbdcBeneficioTemporarioComponent,
        PbdcDashboardComponent
    ],
    providers: [
        PBDCBeneficioPdf,
        PBDCFundoPrevidencialPdf,
        PBDCReservaPoupancaPdf,
        PBDCSuperavitPdf,
        PbdcService
    ]
})
export class PbdcModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/plano/pbdc.module.ts